import { ToolBaseTypes, ToolTypes } from '@labradorsports/constants';

import { Move } from '../models/index.js';
import { getFieldTypeCenter } from '../utils/play.js';

import { PluginContext } from './api.js';

export default {
    baseType: ToolBaseTypes.BALL,
    types: [ToolTypes.BALL],

    handleDragEnd: ({ api, frame }, anchor, offset) => {
        const closest = frame.findClosestPassable(offset, ToolTypes.PASS);

        // If there are no offense, we can't place a ball
        if (!closest) return;

        api.moveInitialBall(closest.id);
    },

    getDefaultMove({ frame, play }, type, offset) {
        const origin =
            offset !== undefined
                ? play.field.clampCoords(offset)
                : getFieldTypeCenter(play.field, play.fieldType, play.config.FieldTypes);
        const closest = frame.findClosestPassable(origin, ToolTypes.PASS);

        // If there are no offense, we can't place a ball
        if (!closest) return null;

        return new Move({
            type,
            target: closest.id,
            origin: closest.origin,
            carrier: closest.id,
        });
    },
} as PlayPlugin<PluginContext>;
